import { Component, Vue, Watch } from 'types-vue'
import "amazon-connect-streams";

@Component
export default class Home extends Vue {}